import { Box, Icon, Text } from '@zillow/constellation-10';
import { IconLockClosedFilled } from '@zillow/constellation-icons';
import Bullet from '../../Bullet';

export type MessageMetaLabelVariant = 'system' | 'eliseAI' | 'valAI';

type MessageMetaLabelProps = {
  metaLabelType: MessageMetaLabelVariant;
};

const MESSAGE_META = {
  system: {
    text: 'Private to you',
    icon: <IconLockClosedFilled />,
  },
  eliseAI: {
    text: 'Powered by EliseAI',
    icon: null,
  },
  valAI: {
    text: 'Powered by Zillow',
    icon: null,
  },
};

export default function MessageMetaLabel({ metaLabelType }: MessageMetaLabelProps): JSX.Element | null {
  const messageMeta = MESSAGE_META[metaLabelType];

  if (!messageMeta) return null;

  return (
    <Box data-testid="message-footer-meta-label" css={{ display: 'flex', alignItems: 'center' }}>
      <Bullet />

      {messageMeta.icon && (
        <Icon
          css={{
            color: 'icon.subtle',
            marginRight: 'tightest',
          }}
        >
          {messageMeta.icon}
        </Icon>
      )}

      <Text
        textStyle="body-xs"
        css={{
          color: 'text.subtle',
        }}
      >
        {messageMeta.text}
      </Text>
    </Box>
  );
}
